import React from "react";

// Substitua os imports abaixo pelas fotos reais da equipe
import nathalie from "./../../assets/images/Nathalie.jpg";
import marilia from "./../../assets/images/Nathalie.jpg";
import ronaldo from "./../../assets/images/Nathalie.jpg";
import renata from "./../../assets/images/Nathalie.jpg";

export default function Equipe() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800">
      {/* Hero */}
      <section className="bg-slate-900 text-white py-20">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Equipe</h1>
          <p className="text-xl md:text-2xl leading-relaxed">
            Profissionais comprometidos com excelência técnica, ética e responsabilidade social
          </p>
        </div>
      </section>

      {/* Conteúdo */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 grid gap-16">
          {/* Nathalie */}
          <div className="grid md:grid-cols-3 gap-10 items-center">
            <img
              src={nathalie}
              alt="Nathalie Guimarães dos Santos"
              className="w-full max-w-xs rounded-2xl shadow-md"
            />
            <div className="md:col-span-2 space-y-4 text-lg md:text-xl leading-relaxed">
              <h2 className="text-2xl md:text-3xl font-bold">
                Nathalie Guimarães dos Santos
              </h2>
              <p>
                Advogada graduada pelas <strong>Faculdades Metropolitanas Unidas (FMU)</strong>,
                especialista em <strong>Direito Penal</strong> e <strong>Compliance Penal</strong>
                pela <strong>Pontifícia Universidade Católica do Rio Grande do Sul (PUC-RS)</strong>.
              </p>
              <p className="font-medium">
                <a
                  href="mailto:nathalie.guimaraes@ngs.adv.br"
                  className="text-slate-700 hover:text-slate-900"
                >
                  nathalie.guimaraes@ngs.adv.br
                </a>
              </p>
            </div>
          </div>

          {/* Marília */}
          <div className="grid md:grid-cols-3 gap-10 items-center">
            <img
              src={marilia}
              alt="Marília de Castro Cabral"
              className="w-full max-w-xs rounded-2xl shadow-md"
            />
            <div className="md:col-span-2 space-y-4 text-lg md:text-xl leading-relaxed">
              <h2 className="text-2xl md:text-3xl font-bold">
                Marília de Castro Cabral
              </h2>
              <p>
                Advogada graduada em 2017 e contadora graduada em 2021 pela
                <strong> Universidade Presbiteriana Mackenzie</strong>, especialista em
                <strong> Direito Tributário</strong> e <strong>Auditoria</strong>, com foco em
                prevenção e contenção de <strong>Responsabilidade Legal</strong>.
              </p>
              <p className="font-medium">
                <a
                  href="mailto:marilia.cabral@ngs.adv.br"
                  className="text-slate-700 hover:text-slate-900"
                >
                  marilia.cabral@ngs.adv.br
                </a>
              </p>
            </div>
          </div>

          {/* Ronaldo */}
          <div className="grid md:grid-cols-3 gap-10 items-center">
            <img
              src={ronaldo}
              alt="Ronaldo Silva Lopes"
              className="w-full max-w-xs rounded-2xl shadow-md"
            />
            <div className="md:col-span-2 space-y-4 text-lg md:text-xl leading-relaxed">
              <h2 className="text-2xl md:text-3xl font-bold">Ronaldo Silva Lopes</h2>
              <p>
                Advogado graduado em 2019 pela <strong>UniEVANGÉLICA – Universidade Evangélica de Goiás</strong>,
                especialista em <strong>Direito Penal</strong> e <strong>Processual Penal</strong>
                pela <strong>Faculdade ATAME</strong>.
              </p>
              <p className="font-medium">
                <a
                  href="mailto:ronaldo.lopes@ngs.adv.br"
                  className="text-slate-700 hover:text-slate-900"
                >
                  ronaldo.lopes@ngs.adv.br
                </a>
              </p>
            </div>
          </div>

          {/* Renata */}
          <div className="grid md:grid-cols-3 gap-10 items-center">
            <img
              src={renata}
              alt="Renata Nunes"
              className="w-full max-w-xs rounded-2xl shadow-md"
            />
            <div className="md:col-span-2 space-y-4 text-lg md:text-xl leading-relaxed">
              <h2 className="text-2xl md:text-3xl font-bold">Renata Nunes</h2>
              <p>
                Assistente executiva e consultora de relacionamento com o cliente,
                atuando no suporte estratégico, organização administrativa e excelência
                no atendimento institucional.
              </p>
              <p className="font-medium">
                <a
                  href="mailto:cliente@ngs.adv.br"
                  className="text-slate-700 hover:text-slate-900"
                >
                  cliente@ngs.adv.br
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
